import React, { useEffect, useState } from "react";
import { getProducts } from "../services/product.service";
import { getCategories } from "../services/category.service";
import { Link } from "react-router-dom";
import ProductCard from "./ProductCard";

const NewArrivalThree = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [productData, categoryData] = await Promise.all([
          getProducts(),
          getCategories()
        ]);
        
        setProducts(productData);
        setFilteredProducts(productData.slice(0, 8));
        setCategories(categoryData);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleFilter = (categoryName) => {
    setActiveCategory(categoryName);
    if (categoryName === "All") {
      setFilteredProducts(products.slice(0, 8));
    } else {
      const filtered = products.filter(p => p.categoryName === categoryName);
      setFilteredProducts(filtered.slice(0, 8));
    }
  };

  return (
    <section className='new-arrival-three py-120 overflow-hidden'>
      <div className='container container-lg'>
        <div className='section-heading mb-40 text-center'>
          <h3 className='mb-0 text-uppercase fw-bold text-gray-900'>OUR PRODUCTS</h3>
          
          <div className="flex-center flex-wrap gap-16 mt-32">
            <button
              onClick={() => handleFilter("All")}
              className={`px-24 py-10 rounded-pill fw-medium transition-2 ${
                activeCategory === "All" 
                ? "bg-main-600 text-white shadow-md" 
                : "bg-white text-gray-600 border border-gray-200 hover-bg-gray-100"
              }`}
              style={activeCategory === "All" ? { backgroundColor: '#016935' } : {}}
            >
              All
            </button>
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => handleFilter(cat.name)}
                className={`px-24 py-10 rounded-pill fw-medium transition-2 ${
                  activeCategory === cat.name 
                  ? "bg-main-600 text-white shadow-md" 
                  : "bg-white text-gray-600 border border-gray-200 hover-bg-gray-100"
                }`}
                style={activeCategory === cat.name ? { backgroundColor: '#016935' } : {}}
              >
                {cat.name}
              </button>
            ))}
          </div>
        </div>
        
        <div className='row gy-4'>
          {loading ? (
            <div className="col-12 text-center py-4">Loading products...</div>
          ) : filteredProducts.length > 0 ? (
            filteredProducts.map((product) => (
              <div key={product.id} className='col-xxl-3 col-xl-4 col-sm-6 col-6'>
                <ProductCard product={product} />
              </div>
            ))
          ) : (
            <div className="col-12 text-center py-4">No products found in this category.</div>
          )}
        </div>
        
        <div className="mt-60 text-center">
            <Link 
              to="/shop" 
              className="btn btn-main rounded-pill px-40 py-18 fw-bold shadow-sm transition-2 hover-translate-y-2 d-inline-flex align-items-center gap-8"
              style={{ backgroundColor: '#016935', color: 'white', border: 'none' }}
            >
              All Products
              <i className="ph ph-arrow-right" />
            </Link>
        </div>
      </div>
    </section>
  );
};

export default NewArrivalThree;
